import { Muted } from '@/components/sv/typographies'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export const InfoBox = ({
  label,
  value,
  className,
}: {
  className?: string
  label: ReactNode
  value: ReactNode
}) => {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      <Muted className="block" as="div">
        {label}
      </Muted>
      <div className="flex items-center gap-2">{value}</div>
    </div>
  )
}
